import { render, staticRenderFns } from "./AccordionPanel.vue?vue&type=template&id=8f4f24f2&"
import script from "./AccordionPanel.vue?vue&type=script&lang=js&"
export * from "./AccordionPanel.vue?vue&type=script&lang=js&"
import style0 from "./AccordionPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports